<div class="wrapper">
  <div>
    <img *ngIf="!isBBGMApplicant"
      class="yourcause-logo"
      src="./assets/img/placeholders/grants-icon-placeholder.svg"
      [alt]="'GLOBAL:textGrantsConnectIcon' | ycI18n: 'GrantsConnect icon'">
    <img *ngIf="isBBGMApplicant"
      src="./assets/img/blackbaud_transparent_logo.png"
      class="blackbaud-logo"
      alt="Blackbaud">
  </div>
</div>